import createClient from '@economic/http-client';

export { createJsonPatchOperation } from '@economic/http-client';

// legacy api client is used for calling endpoints in /secure (eg aspx, ashx)
export default createClient(process.env.ECONOMIC_PATH, undefined);
